import apiClient from "./apiClient";

const Url = `/document`;
// getDocumentFileBlob below uses raw fetch (not apiClient), so it needs the
// full absolute URL - apiClient's baseURL only applies to apiClient calls.
const AbsoluteUrl = `${process.env.REACT_APP_PRO_MODE}/document`;

export const uploadDocument = async (
  props,
  file,
  customerIdOrOptions,
  type,
  category,
) => {
  try {
    const extra =
      customerIdOrOptions && typeof customerIdOrOptions === "object"
        ? customerIdOrOptions
        : {
            customerId: customerIdOrOptions,
            type,
            category,
          };
    let formData = new FormData();
    formData.append("file", file);
    if (extra.customerId) formData.append("customerId", extra.customerId);
    if (extra.type) formData.append("type", extra.type);
    if (extra.category) formData.append("category", extra.category);
    if (extra.module) formData.append("module", extra.module);
    if (extra.recordId) formData.append("recordId", extra.recordId);
    let response = await apiClient.post(Url, formData);

    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const getRecordDocuments = async (props, { module, recordId, customerId }) => {
  try {
    if (customerId && !recordId) {
      return getDocuments(props, customerId);
    }
    const response = await apiClient.get(
      `${Url}/record?module=${encodeURIComponent(module || "")}&recordId=${recordId}`,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getDocumentFileBlob = async (documentId, token) => {
  if (!documentId) throw new Error("documentId is required");
  if (!token) throw new Error("Authentication token missing");

  const res = await fetch(`${AbsoluteUrl}/file/${documentId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    let message = "Could not load file";
    try {
      const errJson = await res.json();
      message = errJson?.message || message;
    } catch (_) {
      /* binary or empty body */
    }
    throw new Error(message);
  }

  const contentType = (res.headers.get("content-type") || "").toLowerCase();
  if (contentType.includes("application/json")) {
    const errJson = await res.json();
    throw new Error(errJson?.message || "Could not load file");
  }

  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  return { url, mime: blob.type || contentType, blob };
};

export const getDocumentFileBlobUrl = async (documentId, token) => {
  const { url } = await getDocumentFileBlob(documentId, token);
  return url;
};

/**
 * Authenticated download for CRM staff (forces save dialog).
 */
export const downloadDocumentFile = async (documentId, token, fileName = "document") => {
  const { url, blob } = await getDocumentFileBlob(documentId, token);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || "document";
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    // Delay revoke so the browser can start the download
    setTimeout(() => window.URL.revokeObjectURL(url), 1500);
  }
  return { blob };
};
export const GetAllDocument = async (
  props,
  currentPage,
  rowsPerPage,
  searchText,
) => {
  try {
    let url = `${Url}/list?page=${currentPage}&limit=${rowsPerPage}`;

    if (
      searchText !== null &&
      searchText !== undefined &&
      searchText.trim() !== ""
    ) {
      url += `&search=${encodeURIComponent(searchText.trim())}`;
    }

    let response = await apiClient.get(url);

    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const getDocuments = async (props, id) => {
  try {
    let url = `${Url}/customer/${id}`;

    let response = await apiClient.get(url);

    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};
export const getDocumentCustomer = async (documentId, props) => {
  try {
    if (!documentId) return false;

    let response = await apiClient.get(`${Url}/${documentId}`);

    if (response?.status === 200) return response.data;

    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const deleteDocument = async (props, documentId) => {
  try {
    if (!documentId) return false;

    let response = await apiClient.delete(`${Url}?documentId=${documentId}`);

    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};
